import React, {FC, ReactNode, useMemo} from 'react';

import {DropdownBoxCoordinator} from '../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {SimpleDropdown} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdown';
import {SimpleDropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdownItem';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {buildCustomFieldLabel} from '../../../../srcCommon/helpers/models/customFieldHelpers';
import {CustomFieldModel} from '../../../models/api/customFieldModel';
import {InlineEditingInputDisplay} from './inlineEditingInputDisplay';

/*
 * Props.
 */

interface InlineEditingDropdownProps {
  value: string;
  customField: CustomFieldModel;
  onEditSave: (arg: string) => void;
  shouldStartInEditMode?: boolean;
  customPlaceholder?: ReactNode;
}

/*
 * Component.
 */

export const InlineEditingEnumDropdown: FC<InlineEditingDropdownProps> = (props) => {
  const {value, customField, onEditSave, shouldStartInEditMode, customPlaceholder} = props;
  const {enumValues} = customField;

  const label = useMemo(() => buildCustomFieldLabel(value, customField), [value, customField]);

  return (
    <InlineEditingInputDisplay>
      <DropdownBoxCoordinator
        value={label ?? customPlaceholder ?? '-'}
        renderDropdown={(popoverProps: PopoverTransferProps) => (
          <SimpleDropdown {...popoverProps} width={popoverProps.anchorWidth}>
            {enumValues?.map((enumValue) => (
              <SimpleDropdownItem
                onSelect={() => onEditSave(enumValue.value)}
                key={enumValue.value}
                isChecked={value === enumValue.value}
              >
                {enumValue.label}
              </SimpleDropdownItem>
            ))}
          </SimpleDropdown>
        )}
        noMargin
        shouldDisablePadding
        isModalInitiallyOpen={shouldStartInEditMode}
      />
    </InlineEditingInputDisplay>
  );
};
